export function parameterize(input: string, separator = '-'): string {
  return input
    .toLowerCase()
    .replace(/[^\w]+/g, ' ')
    .trim()
    .replace(/[_\s]+/g, separator);
}
